import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const FORCE_CHANGE_PATH = '/cambiar-contrasena';

export function ProtectedRoute() {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="auth-page">
        <p className="muted text-center">Cargando sesión…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    const requestedPath = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?redirect=${encodeURIComponent(requestedPath)}`} replace />;
  }

  // Cuenta con contraseña provisional: bloquea todo el panel hasta que la cambie.
  if (user?.mustChangePassword && location.pathname !== FORCE_CHANGE_PATH) {
    return <Navigate to={FORCE_CHANGE_PATH} replace />;
  }

  return <Outlet />;
}

export function GuestRoute() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="auth-page">
        <p className="muted text-center">Cargando…</p>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/panel" replace />;
  }

  return <Outlet />;
}
